/* Emerald - product-tile ritual video (homepage + The System "Built for" split)
 * Binds a short UGC clip to a product tile in the system-split section. On desktop,
 * hovering the tile media fades the muted/looping clip in over the pouch; leaving
 * fades it back. Tap/click opens a lightbox with sound. Keyed by lane, so adding
 * Ignite later is a one-line entry in VIDS.
 * Loaded (defer) from the home-hero and page-hero sections. Self-guards.
 * REMOVE: delete this asset + its includes.
 */
(function () {
  if (window.__emRitual) return; window.__emRitual = true;
  var p = location.pathname;
  var onHome = (p === '/' || p === '');
  var onSys = p.indexOf('/pages/the-system') === 0;
  if (!onHome && !onSys) return;

  var CDN = 'https://cdn.shopify.com';
  // lane -> clip. Add ignite here once its UGC is shot + uploaded.
  var VIDS = {
    supergreens: {
      label: 'Watch the ritual',
      hd: CDN + '/videos/c/vp/b8700a82aec541cbbb37dd8ccd79714f/b8700a82aec541cbbb37dd8ccd79714f.HD-1080p-7.2Mbps-63523076.mp4',
      sd: CDN + '/videos/c/vp/b8700a82aec541cbbb37dd8ccd79714f/b8700a82aec541cbbb37dd8ccd79714f.SD-480p-1.5Mbps-63523076.mp4',
      po: CDN + '/s/files/1/0716/9772/7756/files/preview_images/b8700a82aec541cbbb37dd8ccd79714f.thumbnail.0000000000.jpg?v=1763757740'
    },
    ignite: {
      label: 'Watch the ritual',
      hd: CDN + '/videos/c/vp/f9b73141c2684798b744669504169e33/f9b73141c2684798b744669504169e33.HD-1080p-4.8Mbps-93841275.mp4',
      sd: CDN + '/videos/c/vp/f9b73141c2684798b744669504169e33/f9b73141c2684798b744669504169e33.SD-480p-1.2Mbps-93841275.mp4',
      po: CDN + '/s/files/1/0716/9772/7756/files/preview_images/f9b73141c2684798b744669504169e33.thumbnail.0000000000.jpg?v=1788896901'
    }
  };

  var css = document.createElement('style');
  css.textContent = [
    '.emz-tv{position:absolute;inset:0;border-radius:inherit;overflow:hidden;pointer-events:none;opacity:0;transition:opacity .35s ease;}',
    '.emz-tv.on{opacity:1;}',
    '.emz-tv video{width:100%;height:100%;object-fit:cover;display:block;}',
    '.emz-tvbtn{position:absolute;left:14px;bottom:14px;z-index:3;display:inline-flex;align-items:center;gap:8px;',
      'padding:8px 14px;border:none;border-radius:40px;cursor:pointer;font-family:\'Assistant\',\'Inter\',sans-serif;',
      'font-size:13px;font-weight:600;letter-spacing:.01em;color:#fff;background:rgba(10,99,84,.92);',
      'box-shadow:0 4px 14px rgba(0,0,0,.18);transition:background .2s ease,transform .2s ease;}',
    '.emz-tvbtn:hover{background:#0a6354;transform:translateY(-1px);}',
    '.emz-tvbtn svg{width:13px;height:13px;display:block;}',
    '.emz-tvwrap{position:relative;}',
    '.emz-lb{position:fixed;inset:0;z-index:100000;background:rgba(10,16,12,.85);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;}',
    '.emz-lb.on{opacity:1;}',
    '.emz-lb video{max-height:86vh;max-width:92vw;width:auto;border-radius:14px;background:#000;box-shadow:0 10px 50px rgba(0,0,0,.5);}',
    '.emz-lb__x{position:absolute;top:18px;right:22px;width:44px;height:44px;border-radius:50%;border:none;background:rgba(255,255,255,.15);color:#fff;font-size:26px;cursor:pointer;line-height:1;}'
  ].join('');
  document.head.appendChild(css);

  function openLB(item) {
    var lb = document.createElement('div'); lb.className = 'emz-lb';
    lb.innerHTML = '<button class="emz-lb__x" aria-label="Close">&#215;</button>' +
      '<video controls autoplay playsinline preload="auto" poster="' + item.po + '"><source src="' + item.hd + '" type="video/mp4"></video>';
    document.body.appendChild(lb); document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { lb.classList.add('on'); });
    function close() { try { lb.querySelector('video').pause(); } catch (e) {} lb.remove(); document.body.style.overflow = ''; document.removeEventListener('keydown', esc); }
    function esc(e) { if (e.key === 'Escape') close(); }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('emz-lb__x')) close(); });
    document.addEventListener('keydown', esc);
  }

  function laneFor(tile) {
    var t = (tile.textContent || '').toLowerCase();
    if (t.indexOf('supergreens') !== -1 || t.indexOf('foundation') !== -1) return 'supergreens';
    if (t.indexOf('ignite') !== -1 || t.indexOf('output') !== -1) return 'ignite';
    return null;
  }

  function attach(media, item) {
    if (media.__tv) return; media.__tv = true;
    media.classList.add('emz-tvwrap');
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';

    var tv = document.createElement('div'); tv.className = 'emz-tv';
    tv.innerHTML = '<video muted loop playsinline preload="none" poster="' + item.po + '"></video>';
    var v = tv.querySelector('video');
    media.appendChild(tv);

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'emz-tvbtn';
    btn.setAttribute('aria-label', item.label + ' (opens with sound)');
    btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1.5 L10.5 6 L2 10.5 Z" fill="#fff"/></svg>' + item.label;
    media.appendChild(btn);

    function ensure() { if (!v.src) { v.src = item.sd; v.load(); } }
    function show() { ensure(); v.play().catch(function(){}); tv.classList.add('on'); }
    function hide() { tv.classList.remove('on'); try { v.pause(); } catch(e){} }

    // desktop hover (fine pointer only)
    if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      media.addEventListener('mouseenter', show);
      media.addEventListener('mouseleave', hide);
    }
    // click / tap -> sound lightbox
    media.style.cursor = 'pointer';
    media.setAttribute('role', 'button'); media.setAttribute('tabindex', '0');
    media.addEventListener('click', function () { openLB(item); });
    media.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(item); } });
    btn.addEventListener('click', function (e) { e.stopPropagation(); openLB(item); });
  }

  function bindGroup(tileSel, mediaSel) {
    var tiles = document.querySelectorAll(tileSel);
    if (!tiles.length) return 0;
    var did = 0;
    tiles.forEach(function (tile) {
      var lane = laneFor(tile);
      if (!lane || !VIDS[lane]) return;
      var media = tile.querySelector(mediaSel);
      if (media) { attach(media, VIDS[lane]); did++; }
    });
    return did;
  }

  function build() {
    // Prefer the "Built for" benefits panels (where the pouch hero lives);
    // fall back to the system-split tiles on pages without a benefits section.
    var n = bindGroup('.emv3-benefits__panel', '.emv3-benefits__panel-media');
    if (n > 0) return true;
    n = bindGroup('.emv3-system-split__tile', '.emv3-system-split__media');
    return n > 0;
  }

  function boot() {
    if (build()) return;
    var n = 0, iv = setInterval(function () { if (build() || ++n > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
